// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  z-index: 20;
  padding: 1.25rem 0;
}

.header--overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.header--solid {
  position: sticky;
  top: 0;
  background: rgba(250, 248, 243, 0.92);
  border-bottom: 1px solid var(--line);
  backdrop-filter: blur(10px);
}

.header__inner {
  width: var(--wide);
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.header__logo {
  display: inline-flex;
  align-items: center;
}

.header__nav {
  display: flex;
  align-items: center;
  gap: clamp(1rem, 3vw, 1.75rem);
}

.header__nav a {
  font-size: 0.95rem;
  font-weight: 500;
  transition: color 0.2s ease;
}

.header--overlay .header__nav a {
  color: rgba(255, 255, 255, 0.86);
}

.header--overlay .header__nav a:hover {
  color: #fff;
}

.header--solid .header__nav a {
  color: var(--muted);
}

.header--solid .header__nav a:hover {
  color: var(--ink);
}

.header__cta {
  padding: 0.55rem 0.95rem;
  border: 1px solid transparent;
  border-radius: var(--radius);
}

.header--overlay .header__cta {
  border-color: rgba(255, 255, 255, 0.35);
  color: #fff !important;
}

.header--overlay .header__cta:hover {
  background: rgba(255, 255, 255, 0.1);
}

.header--solid .header__cta {
  border-color: rgba(15, 46, 36, 0.2);
  color: var(--ink) !important;
}

.header--solid .header__cta:hover {
  background: rgba(15, 46, 36, 0.05);
}

@media (max-width: 720px) {
  .header__nav a:not(.header__cta) {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,qCAAqC;EACrC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".header {\r\n  z-index: 20;\r\n  padding: 1.25rem 0;\r\n}\r\n\r\n.header--overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n}\r\n\r\n.header--solid {\r\n  position: sticky;\r\n  top: 0;\r\n  background: rgba(250, 248, 243, 0.92);\r\n  border-bottom: 1px solid var(--line);\r\n  backdrop-filter: blur(10px);\r\n}\r\n\r\n.header__inner {\r\n  width: var(--wide);\r\n  margin: 0 auto;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n}\r\n\r\n.header__logo {\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n.header__nav {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: clamp(1rem, 3vw, 1.75rem);\r\n}\r\n\r\n.header__nav a {\r\n  font-size: 0.95rem;\r\n  font-weight: 500;\r\n  transition: color 0.2s ease;\r\n}\r\n\r\n.header--overlay .header__nav a {\r\n  color: rgba(255, 255, 255, 0.86);\r\n}\r\n\r\n.header--overlay .header__nav a:hover {\r\n  color: #fff;\r\n}\r\n\r\n.header--solid .header__nav a {\r\n  color: var(--muted);\r\n}\r\n\r\n.header--solid .header__nav a:hover {\r\n  color: var(--ink);\r\n}\r\n\r\n.header__cta {\r\n  padding: 0.55rem 0.95rem;\r\n  border: 1px solid transparent;\r\n  border-radius: var(--radius);\r\n}\r\n\r\n.header--overlay .header__cta {\r\n  border-color: rgba(255, 255, 255, 0.35);\r\n  color: #fff !important;\r\n}\r\n\r\n.header--overlay .header__cta:hover {\r\n  background: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.header--solid .header__cta {\r\n  border-color: rgba(15, 46, 36, 0.2);\r\n  color: var(--ink) !important;\r\n}\r\n\r\n.header--solid .header__cta:hover {\r\n  background: rgba(15, 46, 36, 0.05);\r\n}\r\n\r\n@media (max-width: 720px) {\r\n  .header__nav a:not(.header__cta) {\r\n    display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
